__turbopack_context__.v({
  "load6": "loading-module-sass-module__NLL_Cq__load6",
  "loading": "loading-module-sass-module__NLL_Cq__loading",
  "round": "loading-module-sass-module__NLL_Cq__round",
});
